import { v4 as uuidv4 } from "uuid";
export class PAReviewCommentItemModel {
    constructor() {
        this.id = uuidv4();
        this.comments = "";
        this.isEditable = false;
        this.writerName = "";
        this.writerImageUrl = "";
        this.writerNameForPDF = "";
    }
}
export default class PAReviewCommentItem extends PAReviewCommentItemModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
